export interface ReconciliationInputDto {
  date: string; // DateTime -> 'YYYY-MM-DD'
  isLive: boolean;
}

export interface ReconcileResultDto {
  liabilities: number;
  bankProvidersBufferAmount: number;
  allProvidersBufferAmount: number;
  bankProvidersBalances: number;
  bankProvidersReconcileResult: number;
  bankProvidersReconcileResultTitle: string; // EXCESS | SHORTFALL
  bankProvidersReconcileResultMessage: string;
  allProvidersBalances: number;
  allProvidersReconcileResult: number;
  allProvidersReconcileResultTitle: string;
  allProvidersReconcileResultMessage: string;
  cashBookBalanceRc: number;
  internalReconcileResult: number;
  internalReconcileResultTitle: string;
  internalReconcileResultMessage: string;
  lpProvidersEquityRc: number;
  lpProvidersReconcileResult: number;
  lpProvidersReconcileResultTitle: string;
  lpProvidersReconcileResultMessage: string;
  lpSnapshotId: number;
  lpSnapshotAt: string | null;
}

export interface DailyReconcileResultDto {
  internal: ReconcileResultDto;
  external: ReconcileResultDto | null; // null if not permitted
  lp: ReconcileResultDto | null; // null if not permitted OR no snapshot
}

export interface ReconciliationBufferAmountsDto {
  bankBrokerProviders: number;
  allProviders: number;
}

// ReconciliationType: Internal=0, External=1.
export const ReconciliationType = { Internal: 0, External: 1 } as const;
export type ReconciliationType = (typeof ReconciliationType)[keyof typeof ReconciliationType];

// ReconciliationProviderScope: BankBrokerProviders=0, AllProviders=1.
export const ReconciliationProviderScope = { BankBrokerProviders: 0, AllProviders: 1 } as const;
export type ReconciliationProviderScope =
  (typeof ReconciliationProviderScope)[keyof typeof ReconciliationProviderScope];

export interface SaveBufferAmountInputDto {
  reconciliationType: ReconciliationType;
  providerScope: ReconciliationProviderScope;
  amount: number;
}
